class RespondentRecord {
  constructor(data) {
    this.appApplicant = data.app_applicant
    this.appDate = data.app_date
    this.causeNumber = data.cause_number
    this.comments = data.comments
    this.county = data.county
    this.legal = data.legal
    this.meridian = data.meridian
    this.orderDate = data.order_date
    this.orderNumber = data.order_number
    this.phone = data.phone
    this.quarterCall = data.quarter_call
    this.range = data.range
    this.respondent = data.respondent
    this.respondentAddress = data.respondent_address
    this.respondentCity = data.respondent_city
    this.respondentNumber = data.respondent_number
    this.respondentRange = data.respondent_range
    this.respondentSection = data.respondent_section
    this.respondentState = data.respondent_state
    this.respondentTownship = data.respondent_township
    this.respondentZip = data.respondent_zip
    this.scanDate = data.scan_date
    this.section = data.section
    this.source = data.source
    this.sourceUrl = data.source_url
    this.state = data.state
    this.township = data.township
    this.typeOfDocument = data.type_of_document
    this.vaultDataId = data.vaultDataId
  }
}

export default RespondentRecord
